/**
 * Controller: SettingsTerminalsRemoveModal
 */
angular.module('acme.view.application.settings.terminals.removeModal.controllers', [
  'ui.router'
])
.controller('SettingsTerminalsRemoveModalController', [ '$scope', '$uibModalInstance', '$state', 'currentTerminal', function ($scope, $uibModalInstance, $state, currentTerminal) {

    $scope.errors = [];

    $scope.model = {
      displayName: '',
      terminalId: currentTerminal.terminalId,
      name: currentTerminal.name,
      description: currentTerminal.description,
      configId: ''
    };

    $scope.init = function() {

      if (currentTerminal.name) {
        $scope.model.displayName = currentTerminal.name;
      }else{
        $scope.model.displayName = 'Terminal ID: ' + currentTerminal.terminalId;
      }
    };
    


    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);